import swal from 'sweetalert';
import { releasePumpAccountingApplyLock } from './adminApi';

/**
 * SweetAlert v2 returns true/false for custom content — read textarea value from DOM.
 */
export function promptAccountingReason(title, placeholder = 'Min 10 characters — explain why you are running this fix') {
  return swal({
    title,
    content: {
      element: 'textarea',
      attributes: {
        placeholder,
        rows: 3,
      },
    },
    buttons: {
      cancel: {
        text: 'Cancel',
        visible: true,
      },
      confirm: {
        text: 'Continue',
        closeModal: true,
      },
    },
  }).then((confirmed) => {
    if (!confirmed) {
      return null;
    }
    const textarea = document.querySelector('.swal-content__textarea');
    return (textarea?.value || '').trim();
  });
}

export function showAccountingAlert(title, text, icon = 'info') {
  return swal(title, text, icon);
}

/**
 * When apply is blocked by a stale lock, offer to clear it (super-admin only).
 */
export async function showAccountingApplyFailure(pumpId, res, title = 'Fix failed') {
  const message = res?.message || 'Could not apply fix';

  if (!res?.lock_blocked) {
    return showAccountingAlert(title, message, 'error');
  }

  const clearLock = await swal({
    title,
    text: `${message}\n\nIf no fix is running, clear the stuck lock and try again.`,
    icon: 'warning',
    buttons: {
      cancel: 'Wait',
      confirm: {
        text: 'Clear stuck lock',
        value: 'clear',
        closeModal: true,
      },
    },
  });

  if (clearLock !== 'clear') {
    return null;
  }

  const released = await releasePumpAccountingApplyLock(pumpId);
  await showAccountingAlert(
    released.status ? 'Lock cleared' : 'Still busy',
    released.message || 'Unable to clear lock',
    released.status ? 'success' : 'error'
  );

  return released;
}
